import { render, staticRenderFns } from "./ChatRefSighting.vue?vue&type=template&id=09535670&"
import script from "./ChatRefSighting.vue?vue&type=script&lang=js&"
export * from "./ChatRefSighting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports